import type { FC } from 'react';

import {
    TPO_PLAN_DETAILS_FOOTER,
    TPO_PLAN_DETAILS_FOOTER_CREATED_BY,
    TPO_PLAN_DETAILS_FOOTER_EDIT_HOLDER,
    TPO_PLAN_DETAILS_FOOTER_RECORD_COUNT,
} from '../../config/testIds';
import { useTpoGenConfig } from '../../context/CustomerConfigContext';
import { useEditSession } from '../EditSession/EditSessionContext';

export interface PlanDetailsFooterProps {
    loadedCount: number;
    totalCount: number;
    createdBy: string | undefined;
}

const PlanDetailsFooter: FC<PlanDetailsFooterProps> = ({ loadedCount, totalCount, createdBy }) => {
    const tpoGenConfig = useTpoGenConfig();
    const { isHeldByOther, holder } = useEditSession();

    return (
        <div
            className="fixed bottom-14 z-10 left-0 right-0 flex rounded-b-lg border-t border-[#bfbfbf] text-xs text-[#52525c] items-center gap-x-6 bg-[#E4E4E7] mx-4"
            data-testid={TPO_PLAN_DETAILS_FOOTER}
        >
            <div className="flex-1 flex items-center h-8 px-[15px] gap-x-6 min-w-0">
                <p
                    className="whitespace-nowrap"
                    data-testid={TPO_PLAN_DETAILS_FOOTER_RECORD_COUNT}
                    data-state-loaded-count={loadedCount}
                    data-state-total-count={totalCount}
                >
                    {`Showing ${loadedCount.toLocaleString()} of ${totalCount.toLocaleString()} records`}
                </p>
                {isHeldByOther && holder ? (
                    <p className="truncate" data-testid={TPO_PLAN_DETAILS_FOOTER_EDIT_HOLDER}>
                        {tpoGenConfig.labels.editSession.footerEditingBy.replace('{holder}', holder)}
                    </p>
                ) : null}
            </div>
            <div className="flex items-center h-8 px-[15px]">
                <p data-testid={TPO_PLAN_DETAILS_FOOTER_CREATED_BY}>{`Created by: ${createdBy ?? ''}`}</p>
            </div>
        </div>
    );
};

PlanDetailsFooter.displayName = 'PlanDetailsFooter';
export default PlanDetailsFooter;
